import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'
import MEModal from '@CommonComponents/MEModal.js'
import LaunchRecreationInput from './LaunchRecreationInput.js'

const LaunchRecreation = props => {
  const [dialog, toggleDialog] = useState(false)

  const closeDialog = () => {
    toggleDialog(false)
  }

  return (
    <Fragment>
      <a
        onClick={() => toggleDialog(!dialog)}
        className="btn btn-xs-myed btn-default"
      >
        Recreate Launch
      </a>

      <MEModal
        show={dialog}
        close={() => closeDialog()}
        title="Recreate Launch"
      >
        <LaunchRecreationInput log={props.log} />
      </MEModal>
    </Fragment>
  )
}
export default LaunchRecreation

LaunchRecreation.propTypes = {
  log: PropTypes.object,
}
